export const buildDecisionsQuery = (page, pageSize, filterModel, baseFilters = {}) => {
  const query = {
    limit: pageSize,
    page: page,
    ...baseFilters 
  };

  if (filterModel && Array.isArray(filterModel.items)) {
    filterModel.items.forEach((filter) => {
      if (filter.value === undefined || filter.value === null || filter.value === "") return;

      switch (filter.field) {
        case "decision_type": 
          query.decision_type = filter.value; 
          break;
        case "device_id": 
          query.did = filter.value; 
          break;
        case "room": 
          query.room = filter.value; 
          break;
        case "level": 
          query.level = filter.value; 
          break;
        case "execution_status": 
          query.execution_status = filter.value; 
          break;
        case "timestamp_utc":
          if (filter.operator === "onOrAfter") {
            query.since = filter.value;
          } else if (filter.operator === "onOrBefore") {
            query.until = filter.value;
          }
          break;
        default: 
          break;
      }
    });
  }

  return query;
};